// extracted by mini-css-extract-plugin
module.exports = {"paper":"SurveyStatisticsContainer_paper__2n_TZ"};